import { Score } from '@sc/data-access-models';

export class ScoresAddedAction {
  static readonly type = '[Scores] Added';
  constructor(public scores: Score[]) {}
}

export class ScoresClearedAction {
  static readonly type = '[Scores] Cleared';
}
